function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

let subscribers = {};
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

function checkFlexGap() {
  // create flex container with row-gap set
  var flex = document.createElement("div");
  flex.style.display = "flex";
  flex.style.flexDirection = "column";
  flex.style.rowGap = "1px";

  // create two, elements inside it
  flex.appendChild(document.createElement("div"));
  flex.appendChild(document.createElement("div"));

  // append to the DOM (needed to obtain scrollHeight)
  document.body.appendChild(flex);
  var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
  flex.parentNode.removeChild(flex);

  return isSupported;
}
if (checkFlexGap()) {
  document.documentElement.classList.add("flexbox-gap");
} else {
  document.documentElement.classList.add("no-flexbox-gap");
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter((ele) => ele.offsetWidth !== 0 || ele.offsetHeight !== 0);
}

const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function scrolledCheck() {
  if (window.pageYOffset > 0) {
    document.body.classList.add("window-scrolled");
  } else {
    document.body.classList.remove("window-scrolled");
  }
}
scrolledCheck();
window.addEventListener("scroll", scrolledCheck);

function setShortViewportHeight() {
  const value = document.documentElement.clientHeight;
  const currentValue = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--100-svh");
  if (value != currentValue) {
    document.documentElement.style.setProperty("--100-svh", `${value}px`);
  }
}

function setDynamicViewportHeight() {
  const value = window.innerHeight;
  const currentValue = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--100-dvh");

  if (value != currentValue) {
    document.documentElement.style.setProperty("--100-dvh", `${value}px`);
  }
}

function setHeaderTopPosition() {
  const header = document.getElementById("header");
  if (!header) return;
  const value = header.getBoundingClientRect().top;
  const currentValue = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--header-top-position");

  if (value && value != currentValue) {
    document.documentElement.style.setProperty(
      "--header-top-position",
      `${value}px`
    );
  }
}

function setHeaderBottomPosition() {
  const header = document.getElementById("header-wrapper");
  if (!header) return;
  const value = header.getBoundingClientRect().bottom;
  const currentValue = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--header-bottom-position");

  if (value && value != currentValue) {
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${value}px`
    );
  }
}

function setPromobarHeight() {
  const promobar = document.getElementById("promobar");
  if (!promobar) return;
  const value = promobar.getBoundingClientRect().height;
  const currentValue = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--promobar-height");

  if (value && value != currentValue) {
    document.documentElement.style.setProperty(
      "--promobar-height",
      `${value}px`
    );
  }
}

function setHeaderHeight() {
  const header = document.getElementById("header");
  if (!header) return;
  const value = header.getBoundingClientRect().height;
  const currentValue = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--header-height");

  if (value && value != currentValue) {
    document.documentElement.style.setProperty("--header-height", `${value}px`);
  }
}

function setCustomPropertiesOnLoad() {
  setShortViewportHeight();
  setDynamicViewportHeight();

  setPromobarHeight();
  setHeaderHeight();

  setHeaderTopPosition();
  setHeaderBottomPosition();
}

function setCustomPropertiesOnScroll() {
  setPromobarHeight();
  setHeaderHeight();

  setHeaderTopPosition();
  setHeaderBottomPosition();
}

function setCustomPropertiesOnResize() {
  setShortViewportHeight();
  setDynamicViewportHeight();

  setPromobarHeight();
  setHeaderHeight();

  setHeaderTopPosition();
  setHeaderBottomPosition();
}

window.addEventListener("load", setCustomPropertiesOnLoad, false);

window.addEventListener(
  "scroll",
  debounce(setCustomPropertiesOnScroll, 300),
  false
);

window.addEventListener(
  "resize",
  debounce(setCustomPropertiesOnResize, 300),
  false
);

function pauseAllMedia() {
  // document.querySelectorAll(".js-youtube").forEach((video) => {
  //     video.contentWindow.postMessage(
  //         '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
  //         "*"
  //     );
  // });
  // document.querySelectorAll(".js-vimeo").forEach((video) => {
  //     video.contentWindow.postMessage('{"method":"pause"}', "*");
  // });
  // document.querySelectorAll("video").forEach((video) => {
  //     if (video.hasAttribute("control") || video.id.includes("vjs")) {
  //         video.pause();
  //     }
  // });
  // document.querySelectorAll("product-model").forEach((model) => {
  //     if (model.modelViewerUI) model.modelViewerUI.pause();
  // });
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/*
 * Shopify Common JS
 *
 */

document.querySelectorAll("details summary").forEach((summary) => {
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

document.querySelectorAll(".accordion-group").forEach((item) => {
  item.addEventListener("click", function (event) {
    let currentAccordion = event.target.closest(".accordion");
    let currentSummary = event.target.closest(".accordion summary");
    let accordionGroup = event.currentTarget;

    if (!currentSummary) return;
    if (!accordionGroup.contains(currentSummary)) return;

    accordionGroup.querySelectorAll(".accordion").forEach((accordion) => {
      if (accordion != currentAccordion) {
        accordion.removeAttribute("open");
      }
    });
  });
});

class HeaderMega extends HTMLElement {
  constructor() {
    super();

    this.dropdowns = this.querySelectorAll(".header-dropdown");
    this.dropdownToggles = this.querySelectorAll(".header-dropdown-toggle");
    this.dropdownMenus = this.querySelectorAll(".header-dropdown-menu");

    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("keyup", this.onKeyUp.bind(this));

    this.dropdownToggles.forEach((item) => {
      item.addEventListener("click", this.onDropdownToggleClick.bind(this));
    });

    this.dropdowns.forEach((item) => {
      item.addEventListener("focusout", this.onDropdownFocusOut.bind(this));
      item.addEventListener("mouseenter", this.onDropdownMouseEnter.bind(this));
      item.addEventListener("mouseleave", this.onDropdownMouseLeave.bind(this));
    });

    this.dropdownMenus.forEach((item) => {
      item.addEventListener("mouseleave", this.onDropdownMouseLeave.bind(this));
    });
  }

  onDropdownToggleClick(event) {
    event.preventDefault();

    const dropdownToggle = event.currentTarget;
    const dropdown = dropdownToggle.parentNode;

    if (this.isDropdownOpen(dropdown)) {
      this.closeDropdown(dropdown);
      this.closeMega();
    } else {
      this.openDropdown(dropdown);
      this.openMega();
    }
  }

  onDropdownMouseEnter(event) {
    const dropdown = event.currentTarget;

    if (this.hasDropdownOpen()) {
      if (this.isDropdownClose(dropdown)) {
        this.openTimer = setTimeout(() => {
          if (this.closeTimer) {
            clearTimeout(this.closeTimer);
          }
          this.closeAllDropdowns();
          this.openDropdown(dropdown);
        }, 100);
      } else {
        if (this.closeTimer) {
          clearTimeout(this.closeTimer);
        }
        if (this.openTimer) {
          clearTimeout(this.openTimer);
        }
      }
    } else {
      this.openDropdown(dropdown);
      this.openMega();
    }
  }

  onDropdownMouseLeave(event) {
    const dropdown = event.currentTarget;

    if (this.isDropdownOpen(dropdown)) {
      this.closeTimer = setTimeout(() => {
        this.closeDropdown(dropdown);
        this.closeMega();
      }, 200);
    }
  }

  onDropdownFocusOut(event) {
    if (
      !(event.relatedTarget && event.relatedTarget.closest(".header-wrapper"))
    ) {
      if (this.hasDropdownOpen()) {
        this.closeAllDropdowns();
        this.closeMega();
      }
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    this.closeDropdown(openDetailsElement);
    this.closeMega();
  }

  isDropdownOpen(detailsElement) {
    return (
      detailsElement.hasAttribute("open") &&
      detailsElement.classList.contains("open")
    );
  }

  isDropdownClose(detailsElement) {
    return !detailsElement.hasAttribute("open");
  }

  hasDropdownOpen() {
    return this.classList.contains("dropdown-open");
  }

  openDropdown(detailsElement) {
    const summaryElement = detailsElement.querySelector("summary");

    // close all sub drawers
    this.closeAllDropdowns();

    detailsElement.setAttribute("open", "");
    detailsElement.classList.add("open");
    summaryElement.setAttribute("aria-expanded", true);

    // update status
    this.classList.add("dropdown-open");

    // trap focus
    trapFocus(detailsElement, summaryElement);
  }

  closeDropdown(detailsElement) {
    const summaryElement = detailsElement.querySelector("summary");

    detailsElement.removeAttribute("open");
    detailsElement.classList.remove("open");

    summaryElement.setAttribute("aria-expanded", false);

    // remove trap focus
    removeTrapFocus(summaryElement);

    // close sub drawer animation

    // update status
    this.classList.remove("dropdown-open");
  }

  closeAllDropdowns() {
    this.dropdowns.forEach((item) => {
      if (this.isDropdownOpen(item)) {
        this.closeDropdown(item);
      }
    });
  }

  openMega() {
    document.body.classList.add("header-mega-open", "overflow-hidden");
  }

  closeMega() {
    document.body.classList.remove("header-mega-open", "overflow-hidden");
  }
}
customElements.define("header-mega", HeaderMega);

class HeaderDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawerContainer = this.querySelector(".header-drawer-container");
    this.drawerToggle = this.drawerContainer.querySelector(
      ".header-drawer-toggle"
    );
    this.drawerCloseButton = this.drawerContainer.querySelector(
      ".header-drawer-close"
    );
    this.drawer = this.drawerContainer.querySelector(".header-drawer");
    this.drawerLink = this.drawerContainer.querySelectorAll(
      ".header-drawer-menu-link"
    );

    this.subDrawerContainers = this.drawerContainer.querySelectorAll(
      ".header-subdrawer-container"
    );
    this.subDrawerToggles = this.drawerContainer.querySelectorAll(
      ".header-subdrawer-toggle"
    );

    this.subDrawerCloseButtons = this.drawerContainer.querySelectorAll(
      ".header-subdrawer-close"
    );
    this.subDrawers =
      this.drawerContainer.querySelectorAll(".header-subdrawer");

    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onDrawerFocusOut.bind(this));

    this.drawerToggle.addEventListener(
      "click",
      this.onDrawerToggleClick.bind(this)
    );
    this.drawerCloseButton.addEventListener(
      "click",
      this.onDrawerCloseButtonClick.bind(this)
    );

    this.subDrawerToggles.forEach((item) => {
      item.addEventListener("click", this.onSubDrawerToggleClick.bind(this));
    });

    this.subDrawerCloseButtons.forEach((item) => {
      item.addEventListener(
        "click",
        this.onSubDrawerCloseButtonClick.bind(this)
      );
    });

    this.subDrawerContainers.forEach((item) => {
      item.addEventListener("focusout", this.onSubDrawerFocusOut.bind(this));
    });
  }

  onDrawerToggleClick(event) {
    event.preventDefault();

    if (this.isDrawerOpen()) {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  }

  onDrawerCloseButtonClick(event) {
    event.preventDefault();
    this.closeDrawer();
  }

  onSubDrawerToggleClick(event) {
    event.preventDefault();

    const subDrawerToggle = event.currentTarget;
    const subDrawerContainer = subDrawerToggle.parentNode;

    if (this.isSubDrawerOpen(subDrawerContainer)) {
      this.closeSubDrawer(subDrawerContainer);
    } else {
      this.openSubDrawer(subDrawerContainer);
    }
  }

  onSubDrawerCloseButtonClick(event) {
    event.preventDefault();

    const detailsElement = event.currentTarget.closest("details");
    this.closeSubDrawer(detailsElement);
  }

  onDrawerFocusOut(event) {
    const relatedTarget = event.relatedTarget;
    setTimeout(() => {
      if (this.isDrawerOpen() && !this.drawerContainer.contains(relatedTarget))
        this.closeDrawer();
    });
  }

  onSubDrawerFocusOut(event) {
    const subDrawerContainer = event.currentTarget;
    const relatedTarget = event.relatedTarget;
    setTimeout(() => {
      if (this.hasSubDrawerOpen() && relatedTarget === this.drawer)
        this.closeSubDrawer(subDrawerContainer);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    if (openDetailsElement === this.drawerContainer) {
      this.closeDrawer(this.drawerToggle);
    } else {
      this.closeSubDrawer(openDetailsElement);
    }
  }

  isDrawerOpen() {
    return (
      this.drawerContainer.hasAttribute("open") &&
      this.drawerContainer.classList.contains("open")
    );
  }

  isSubDrawerOpen(detailsElement) {
    return (
      detailsElement.hasAttribute("open") &&
      detailsElement.classList.contains("open")
    );
  }

  isSubDrawerClose(detailsElement) {
    return !detailsElement.hasAttribute("open");
  }

  hasSubDrawerOpen() {
    return this.drawerContainer.classList.contains("subdrawer-open");
  }

  openDrawer() {
    // open drawer
    setTimeout(() => {
      this.drawerContainer.setAttribute("open", "");
      this.drawerToggle.setAttribute("aria-expanded", true);
    });

    // trap focus
    trapFocus(this.drawerContainer, this.drawerToggle);

    // update status
    document.body.classList.add("header-drawer-open", "overflow-hidden");
  }

  openSubDrawer(detailsElement) {
    const summaryElement = detailsElement.querySelector("summary");

    // close all sub drawers
    this.closeAllSubDrawers();

    // open sub drawer
    setTimeout(() => {
      detailsElement.setAttribute("open", "");
      summaryElement.setAttribute("aria-expanded", true);
    });

    // trap focus
    trapFocus(detailsElement, summaryElement);

    // update status
    this.drawerContainer.classList.add("subdrawer-open");
  }

  closeDrawer(elementToFocus = false) {
    // remove trap focus
    removeTrapFocus(elementToFocus);

    // close drawer
    this.drawerContainer.removeAttribute("open");
    this.drawerToggle.setAttribute("aria-expanded", false);

    // close all sub drawers
    this.closeAllSubDrawers();

    // update status
    document.body.classList.remove("header-drawer-open", "overflow-hidden");
  }

  closeSubDrawer(detailsElement) {
    const summaryElement = detailsElement.querySelector("summary");
    const menuElement = summaryElement.nextElementSibling;

    // remove trap focus
    removeTrapFocus(summaryElement);

    // close sub drawer

    detailsElement.removeAttribute("open");
    summaryElement.setAttribute("aria-expanded", false);

    // update status
    this.drawerContainer.classList.remove("subdrawer-open");
  }

  closeAllSubDrawers() {
    this.subDrawerContainers.forEach((item) => {
      if (this.isSubDrawerOpen(item)) {
        this.closeSubDrawer(item);
      }
    });
  }
}
customElements.define("header-drawer", HeaderDrawer);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define("menu-drawer", MenuDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.onModalClickBound = this.onModalClick.bind(this);

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });

    if (this.classList.contains("media-modal")) {
      this.addEventListener("click", this.onMediaClick.bind(this));
    } else {
      this.addEventListener("click", this.onModalClickBound);
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  onMediaClick(event) {
    this.hide();
  }

  onModalClick(event) {
    if (event.target === this) this.hide();
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.querySelector('[role="dialog"]').classList.add("active");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    if (
      this.querySelector('[role="dialog"]').classList.contains(
        "modal-dialog--animation"
      )
    ) {
      this.querySelector('[role="dialog"]').addEventListener(
        "transitionend",
        () => {
          window.pauseAllMedia();
          removeTrapFocus(this.openedBy);
          this.removeAttribute("open");
          document.body.classList.remove("overflow-hidden");
          document.body.dispatchEvent(new CustomEvent("modalClosed"));
        },
        { once: true }
      );

      this.querySelector('[role="dialog"]').classList.remove("active");
    } else {
      window.pauseAllMedia();
      removeTrapFocus(this.openedBy);
      this.querySelector('[role="dialog"]').classList.remove("active");
      this.removeAttribute("open");
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
    }
  }
}
customElements.define("modal-dialog", ModalDialog);

class NewsletterModal extends ModalDialog {
  constructor() {
    super();

    this.initialDelay = 0;
    this.idleTime = 0;

    if (!Cookies.get("newsletter_modal")) {
      this.init();
    }
  }

  init() {
    document.addEventListener("mousemove", function (e) {
      this.idleTime = 0;
    });
    document.addEventListener("keydown", function (e) {
      this.idleTime = 0;
    });

    this.initialDelayInterval = setInterval(
      this.timerIncrement.bind(this),
      1000
    );

    this.idleTimeInterval = setInterval(this.timerIncrement.bind(this), 1000);
  }

  isOverflowHidden() {
    return getComputedStyle(document.documentElement).overflow == "hidden" ||
      getComputedStyle(document.body).overflow == "hidden"
      ? true
      : false;
  }

  timerIncrement() {
    this.initialDelay = this.initialDelay + 1;
    this.idleTime = this.idleTime + 1;
    this.tryOpenPopup();
  }

  tryOpenPopup() {
    if (
      this.initialDelay >= 20 &&
      this.idleTime >= 3 &&
      !this.isOverflowHidden()
    ) {
      this.show();

      Cookies.set("newsletter_modal", "true", {
        expires: 7,
      });

      clearInterval(this.initialDelayInterval);
      clearInterval(this.idleTimeInterval);
    }
  }
}
customElements.define("newsletter-modal", NewsletterModal);

class CookieModal extends ModalDialog {
  constructor() {
    super();

    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      function (error) {
        if (error) {
          throw error;
        }
        this.initCookieBanner();
      }.bind(this)
    );

    this.cookieAcceptButton = this.querySelector(".cookie-modal-cta--accept");
    this.cookieCloseButton = this.querySelector(".cookie-modal-cta--close");
    this.modalCloseButton = this.querySelector(".modal-close");

    this.bindEvents();
  }

  bindEvents() {
    this.cookieAcceptButton.addEventListener(
      "click",
      this.handleAccept.bind(this)
    );
    this.cookieCloseButton.addEventListener("click", this.hide.bind(this));
    this.modalCloseButton.addEventListener(
      "click",
      this.handleAccept.bind(this)
    );

    this.removeEventListener("click", this.onModalClickBound);
  }

  handleAccept() {
    window.Shopify.customerPrivacy.setTrackingConsent(
      true,
      this.hide.bind(this)
    );

    document.addEventListener("trackingConsentAccepted", function () {});
  }

  handleDecline() {
    window.Shopify.customerPrivacy.setTrackingConsent(
      false,
      this.hide.bind(this)
    );
  }

  initCookieBanner() {
    if (window.Shopify.customerPrivacy.shouldShowGDPRBanner()) {
      this.show();
    }
  }
}
customElements.define("cookie-modal", CookieModal);

class GeolocationModal extends ModalDialog {
  constructor() {
    super();

    this.countryList = JSON.parse(
      document.querySelector("#geolocation-modal-data").textContent
    );
    this.currentStoreCountryISO = window.Shopify.country;

    this.detectionCountryNameEle = document.querySelector(
      "#geolocation-modal-detection-country-name"
    );
    this.detectionMessageEle = document.querySelector(
      ".geolocation-modal-detection-message"
    );
    this.detectionLinkEleList = document.querySelectorAll(
      ".geolocation-modal-detection-link"
    );
    this.storeItemEleList = document.querySelectorAll(
      ".geolocation-modal-store-disclosure-menu-item"
    );

    if (!Cookies.get("geolocation_modal")) {
      navigator.geolocation.getCurrentPosition(
        this.geoSuccess.bind(this),
        this.geoError.bind(this)
      );
    }
  }

  geoSuccess(position) {
    this.getDetectionCountry().then(this.update.bind(this));
  }

  geoError(error) {
    console.warn(`ERROR(${error.code}): ${error.message}`);
  }

  async getDetectionCountry() {
    const response = await fetch(
      window.Shopify.routes.root +
        "browsing_context_suggestions.json" +
        "?country[enabled]=true"
    ).then((response) => response.json());

    return response;
  }

  update(response) {
    const detectedCountryISO = response.detected_values.country.handle;
    const detectedCountryName = response.detected_values.country.name;

    this.updateDetectedCountryName(detectedCountryName);

    if (this.hasMatchedStore(detectedCountryISO)) {
      this.updateDetectedLink(detectedCountryISO);
      this.updateStoreList(detectedCountryISO);
    } else {
      this.updateDetectedLink(this.currentStoreCountryISO);
      this.showNoMatchedStoreMessage();
    }

    this.setCookie();
    this.show();
  }

  hasMatchedStore(countryISO) {
    return this.countryList.countries.some((country) => {
      return country.iso_code == countryISO;
    });
  }

  showNoMatchedStoreMessage() {
    this.detectionMessageEle.classList.remove("hidden");
  }

  updateDetectedCountryName(countryName) {
    this.detectionCountryNameEle.innerHTML = countryName;
  }

  updateDetectedLink(countryISO) {
    const results = Array.from(this.detectionLinkEleList).filter(
      (item) => item.dataset.isoCode !== countryISO
    );

    results.forEach((item) => item.remove());
  }

  updateStoreList(countryISO) {
    const results = Array.from(this.storeItemEleList).filter(
      (item) => item.dataset.isoCode == countryISO
    );

    results.forEach((item) => item.remove());
  }

  setCookie() {
    Cookies.set("geolocation_modal", "true", {
      expires: 30,
    });
  }
}
customElements.define("geolocation-modal", GeolocationModal);

class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".product-gallery-slider");
    this.script = this.querySelector('[type="application/json"]');
    this.variantDefaultData = this.getDefaultVariantData();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSlider();
  }

  refresh(variantData) {
    /* Need Refactoring */
    // Add a check to ensure this.sliderSwiper is defined
    if (!this.sliderSwiper || !this.sliderSwiper.slides) {
      console.error("sliderSwiper or sliderSwiper.slides is undefined");
      return;
    }

    this.sliderSwiper.slides.every((slide) => {
      var scrollIndex = parseInt(slide.dataset.scrollIndex, 10);
      scrollIndex += 1;
      var ariaLabel = 0;
      var slider = document.querySelectorAll(
        ".product-gallery-slider .swiper-slide"
      );

      if (slide.dataset.variantTitle == variantData.title) {
        slider.forEach(function (item) {
          var ariaLabelNew = item.getAttribute("aria-label");
          if (ariaLabelNew) {
            var firstValue = parseInt(ariaLabelNew.split("/")[0].trim(), 10);

            if (firstValue === scrollIndex) {
              ariaLabel = firstValue;
            }
          }
        });

        ariaLabel = slide.getAttribute("aria-label");
        var parts = ariaLabel.split("/");
        var firstNumber = parseInt(parts[0].trim(), 10);
        var result = firstNumber - 1;

        this.sliderSwiper.slideTo(result, 400, true);
        console.log("slide to: ", result);

        return false;
      }

      return true;
    });
    // if (this.sliderSwiper) {
    // this.destroySlider(this.sliderSwiper);
    // }
    // this.initSlider();
  }

  getDefaultVariantData() {
    return JSON.parse(this.script.textContent);
  }

  initSlider() {

    
           // 
             if (!this.slider || !(this.slider instanceof Element)) {
                console.warn("ProductGallery: valid slider element not found");
                 return;
             }

            const wrapper = this.slider.querySelector(".swiper-wrapper");
            const slides = this.slider.querySelectorAll(".swiper-slide");

           if (!wrapper || slides.length === 0) {
                console.warn("ProductGallery: swiper-wrapper or swiper-slide not found");
             return;
           }
           // 


    this.sliderSwiper = new Swiper(this.slider, {
      slidesPerView: 1.5,
      spaceBetween: 10,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 50,
      speed: 400,
      grabCursor: true,
      pagination: false,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        // when window width is >= 1200px
        1200: {
          slidesPerView: 1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 50,
        },
      },
      focusableElements: ".focusDisableSwiper",
      navigation: {
        prevEl: this.slider.querySelector(".swiper-nav-button--prev"),
        nextEl: this.slider.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true,
      },
      on: {
        activeIndexChange: function (swiper) {
          const currentSlideVideo =
            swiper.slides[swiper.activeIndex].querySelector("video");
          const previousSlideVideo =
            swiper.slides[swiper.previousIndex].querySelector("video");
          if (previousSlideVideo) {
            previousSlideVideo.pause();
          }
          if (currentSlideVideo) {
            currentSlideVideo.play();
          }
        },
      },
    });

    // Move the refresh call to connectedCallback to ensure this.sliderSwiper is initialized
    this.refresh(this.variantDefaultData);
  }

  destroySlider(swiper) {
    swiper.destroy(true, true);
  }
}
customElements.define("product-gallery", ProductGallery);

class ProductComplementary extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const complementary = html.querySelector("product-complementary");

        if (complementary && complementary.innerHTML.trim().length) {
          this.innerHTML = complementary.innerHTML;
        }

        this.carousel = this.querySelector(".swiper");

        this.swiper = new Swiper(this.carousel, {
          loop: false,
          grabCursor: true,
          slidesPerView: 2.2,
          spaceBetween: 2,
          centerInsufficientSlides: true,
          mousewheel: {
            forceToAxis: true,
          },
          freeMode: {
            enabled: true,
            sticky: false,
          },
          navigation: {
            prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
            nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
            disabledClass: "hidden",
          },
          breakpoints: {
            768: {
              slidesPerView: 3.2,
            },
            992: {
              slidesPerView: 3.2,
            },
            1200: {
              slidesPerView: 4.2,
            },
          },
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("product-complementary", ProductComplementary);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.carousel = this.querySelector(".swiper");

        this.swiper = new Swiper(this.carousel, {
          loop: false,
          grabCursor: true,
          slidesPerView: 1.05,
          spaceBetween: 10,
          centerInsufficientSlides: true,
          mousewheel: {
            forceToAxis: true,
          },
          freeMode: {
            enabled: true,
            sticky: false,
          },
          navigation: {
            prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
            nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
            disabledClass: "hidden",
          },
          breakpoints: {
            1199: {
              slidesPerView: 2.9,
              spaceBetween: 15,
            },
          },
        });

        const nextBtn = document.querySelector(
          ".product-recommendations .swiper-nav-button--next"
        );
        const prevBtn = document.querySelector(
          ".product-recommendations .swiper-nav-button--prev"
        );

        nextBtn.addEventListener("click", () => {
          if (this.swiper.activeIndex >= 0) {
            prevBtn.classList.remove("disabled");
          }

          this.swiper.slideNext();
        });

        prevBtn.addEventListener("click", () => {
          if (this.swiper.activeIndex <= 7) {
            nextBtn.classList.remove("disabled");
          }

          this.swiper.slidePrev();
        });

        this.swiper.on("reachEnd", function () {
          nextBtn.classList.add("disabled");
        });
        this.swiper.on("reachBeginning", function () {
          prevBtn.classList.add("disabled");
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      "click",
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
  }
}
customElements.define("details-modal", DetailsModal);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.details.querySelector("summary");
    this.content = this.summary.nextElementSibling;

    this.details.addEventListener("focusout", this.onFocusOut.bind(this));
    this.summary.addEventListener("click", this.onToggle.bind(this));
    this.details.addEventListener("mouseenter", this.onMouseEnter.bind(this));
    this.details.addEventListener("mouseleave", this.onMouseLeave.bind(this));
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onMouseEnter(event) {
    this.openTimer = setTimeout(() => {
      this.open();
    }, 200);
  }

  onMouseLeave(event) {
    if (this.openTimer) {
      clearTimeout(this.openTimer);
    }
    this.close();
  }

  onToggle(event) {
    event.preventDefault();
    if (this.details.open) {
      this.close();
    } else {
      this.open();
    }
  }

  open(event) {
    this.details.setAttribute("open", true);
    this.details.querySelector("summary").setAttribute("aria-expanded", true);
  }

  close(event) {
    this.details.removeAttribute("open");
    this.details.querySelector("summary").setAttribute("aria-expanded", false);
  }
}
customElements.define("details-disclosure", DetailsDisclosure);

class PromoBar extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector(".swiper");
  }
  connectedCallback() {
    this.swiper = new Swiper(this.slider, {
      loop: true,
      speed: 400,
      allowTouchMove: false,
      followFinger: false,
      simulateTouch: false,
      navigation: {
        prevEl: this.slider.querySelector(".swiper-nav-button--prev"),
        nextEl: this.slider.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
      },
    });
  }
}
customElements.define("promo-bar", PromoBar);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.links = this.form.querySelectorAll("a");
    this.input = this.form.querySelector(
      'input[name="locale_code"], input[name="country_code"]'
    );

    this.links.forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    this.input.value = event.currentTarget.dataset.value;
    if (this.form) this.form.submit();
  }
}
customElements.define("localization-form", LocalizationForm);

class HomePageSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector(".swiper");

    this.sliderAutoplayEnable =
      this.slider.dataset.sliderAutoplayEnable === "true";
    this.sliderAutoplayInterval = this.slider.dataset.sliderAutoplayInterval;

    this.dataSliderSlidesToShow = this.slider.dataset.sliderSlidesToShow
      ? this.slider.dataset.sliderSlidesToShow
      : 1;
    this.sliderSlidesToShowMobile = this.slider.dataset.sliderSlidesToShowMobile
      ? this.slider.dataset.sliderSlidesToShowMobile
      : 1;

    this.sliderSpaceBetweenSlides = this.slider.dataset.sliderSpaceBetweenSlides
      ? this.slider.dataset.sliderSpaceBetweenSlides
      : 20;
    this.sliderSpaceBetweenSlidesMobile = this.slider.dataset
      .sliderSpaceBetweenSlidesMobile
      ? this.slider.dataset.sliderSpaceBetweenSlidesMobile
      : 20;
  }
  connectedCallback() {
    let scrollSlider = this.slider.classList.contains(
      "hp-scrolling-image-banner"
    );

    this.swiper = new Swiper(this.slider, {
      slidesPerView: Math.abs(this.sliderSlidesToShowMobile),
      spaceBetween: Math.abs(this.sliderSpaceBetweenSlidesMobile),
      loop: true,
      speed: 1500,
      grabCursor: true,
      autoplay: this.sliderAutoplayEnable
        ? {
            delay: scrollSlider ? 1 : this.sliderAutoplayInterval,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          }
        : false,
      breakpoints: {
        991: {
          slidesPerView: Math.abs(this.dataSliderSlidesToShow),
          spaceBetween: Math.abs(this.sliderSpaceBetweenSlides),
        },
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        prevEl: this.slider.querySelector(".swiper-nav-button--prev"),
        nextEl: this.slider.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        clickable: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true,
      },
      on: {
        slideChangeTransitionStart: function (swiper, speed, internal) {
          // get the control color of the next slide
          const activeSlide = swiper.slides[swiper.activeIndex];
          const activeSlideControlColor =
            activeSlide.dataset.sliderControlColor;
          // spread the control color to slider
          swiper.el.style.setProperty(
            "--swiper-theme-color",
            activeSlideControlColor
          );
          swiper.el.style.setProperty(
            "--swiper-navigation-color",
            activeSlideControlColor
          );
        },
      },
    });

    const scrollingImageSlider = document.querySelector(
      ".hp-scrolling-image-banner"
    );

    scrollingImageSlider.addEventListener("mouseenter", function () {
      this.swiper.autoplay.stop();
    });
    scrollingImageSlider.addEventListener("mouseleave", function () {
      this.swiper.autoplay.start();
    });
  }
}
customElements.define("homepage-slider", HomePageSlider);

class PageSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector(".swiper");

    this.sliderAutoplayEnable =
      this.slider.dataset.sliderAutoplayEnable === "true";
    this.sliderAutoplayInterval = this.slider.dataset.sliderAutoplayInterval;

    this.dataSliderSlidesToShow = this.slider.dataset.sliderSlidesToShow
      ? this.slider.dataset.sliderSlidesToShow
      : 1;
    this.sliderSlidesToShowMobile = this.slider.dataset.sliderSlidesToShowMobile
      ? this.slider.dataset.sliderSlidesToShowMobile
      : 1;

    this.sliderSpaceBetweenSlides = this.slider.dataset.sliderSpaceBetweenSlides
      ? this.slider.dataset.sliderSpaceBetweenSlides
      : 20;
    this.sliderSpaceBetweenSlidesMobile = this.slider.dataset
      .sliderSpaceBetweenSlidesMobile
      ? this.slider.dataset.sliderSpaceBetweenSlidesMobile
      : 20;
  }
  connectedCallback() {
    this.swiper = new Swiper(this.slider, {
      slidesPerView: Math.abs(this.sliderSlidesToShowMobile),
      spaceBetween: Math.abs(this.sliderSpaceBetweenSlidesMobile),
      loop: true,
      speed: 400,
      grabCursor: true,
      parallax: true,
      autoplay: this.sliderAutoplayEnable
        ? {
            delay: 3000,
            pauseOnMouseEnter: false,
            disableOnInteraction: true,
          }
        : false,
      breakpoints: {
        991: {
          slidesPerView: Math.abs(this.dataSliderSlidesToShow),
          spaceBetween: Math.abs(this.sliderSpaceBetweenSlides),
        },
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        prevEl: this.slider.querySelector(".swiper-nav-button--prev"),
        nextEl: this.slider.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      pagination: {
        el: this.slider.querySelector(".swiper-pagination"),
        type: "custom",
        renderCustom: function (swiper, current, total) {
          return current + " | " + total;
        },
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
        pageUpDown: true,
      },
      on: {
        slideChangeTransitionStart: function (swiper, speed, internal) {
          // get the control color of the next slide
          const activeSlide = swiper.slides[swiper.activeIndex];
          const activeSlideControlColor =
            activeSlide.dataset.sliderControlColor;
          // spread the control color to slider
          swiper.el.style.setProperty(
            "--swiper-theme-color",
            activeSlideControlColor
          );
          swiper.el.style.setProperty(
            "--swiper-navigation-color",
            activeSlideControlColor
          );
        },
      },
    });
  }
}
customElements.define("page-slider", PageSlider);
class HomePageProductCarousel extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector(".swiper");
  }
  connectedCallback() {
    this.swiper = new Swiper(this.carousel, {
      grabCursor: true,
      slidesPerView: 1.5,
      spaceBetween: 2,
      centerInsufficientSlides: false,
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: true,
        sticky: false,
      },
      navigation: {
        prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
        nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        992: {
          slidesPerView: 3.2,
        },
        1200: {
          slidesPerView: 4.2,
        },
      },
    });
  }
}
customElements.define("homepage-product-carousel", HomePageProductCarousel);

class productpageIngredientCarousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        prevEl: this.querySelector(".swiper-nav-button--prev"),
        nextEl: this.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
    });
  }
}
customElements.define(
  "productpage-ingredient-carousel",
  productpageIngredientCarousel
);

class VideojsSimpleControl extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.video = this.querySelector("video-js");
    this.aspectRatio = this.dataset.aspectRatio;

    this.videojsPlayer = videojs(this.video, {
      aspectRatio: this.aspectRatio,
      fluid: true,
      responsive: true,
      inactivityTimeout: 0,
      bigPlayButton: false,
      controlBar: {
        volumePanel: false,
        muteToggle: true,
        subsCapsButton: true,
        progressControl: true,
        remainingTimeDisplay: true,
        pictureInPictureToggle: false,
        fullscreenToggle: true,
      },
    }).player();

    this.observer = new IntersectionObserver(
      function (entries) {
        if (entries[0]["isIntersecting"] === true) {
          this.videojsPlayer.muted(false);
        } else {
          this.videojsPlayer.muted(true);
        }
      }.bind(this),
      { root: null, rootMargin: "0px", threshold: 0 }
    );

    // Pause Other videos when one plays.
    this.video.addEventListener("click", function () {
      if (this.classList.contains("vjs-playing")) {
        return;
      }
      var allPlayingVideos = document.querySelectorAll(".video-js.vjs-playing");
      if (allPlayingVideos.length > 0) {
        allPlayingVideos.forEach((item) => {
          item.querySelector(".vjs-tech").pause();
          item.classList.add("vjs-paused");
          this.querySelector(".vjs-tech").play();
        });
      }
    });

    this.observer.observe(this);
  }
}
customElements.define("video-js-simple-control", VideojsSimpleControl);

class VideojsFullControl extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.video = this.querySelector("video-js");
    this.aspectRatio = this.dataset.aspectRatio;

    this.videojsPlayer = videojs(this.video, {
      aspectRatio: this.aspectRatio,
      fluid: true,
      responsive: true,
      inactivityTimeout: 0,
      bigPlayButton: true,
      controlBar: {
        subsCapsButton: false,
        pictureInPictureToggle: false,
      },
    }).player();

    this.observer = new IntersectionObserver(
      function (entries) {
        if (entries[0]["isIntersecting"] === true) {
        } else {
          this.videojsPlayer.muted(true);
        }
      }.bind(this),
      { root: null, rootMargin: "0px", threshold: 0 }
    );

    this.observer.observe(this);
  }
}
customElements.define("video-js-full-control", VideojsFullControl);

class VideojsNoControl extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.video = this.querySelector("video-js");
    this.videojsPlayer = videojs(this.video, {
      aspectRatio: "1:1",
      fluid: true,
      responsive: true,
      inactivityTimeout: 0,
      bigPlayButton: false,
      controls: false,
    }).player();
  }
}
customElements.define("video-js-no-control", VideojsNoControl);

class NewsletterForm extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.ajaxFormInit(this.querySelector("form"));
  }

  formToJSON(elements) {
    return [].reduce.call(
      elements,
      function (data, element) {
        data[element.name] = element.value;
        return data;
      },
      {}
    );
  }

  // Get Shopify Friendly URL String
  getUrlString(data) {
    var urlParameters = Object.entries(data)
      .map(function (e) {
        return e.join("=");
      })
      .join("&");

    return urlParameters;
  }

  getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  }

  isEmail(email) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    );
  }

  ajaxFormInit(form) {
    const action = form.getAttribute("action"),
      form_type = form.querySelector('[name="form_type"]').value,
      inputs = form.querySelectorAll("[name]"),
      submitBtn = form.querySelector('[type="submit"]'),
      emailInput = form.querySelector('input[name="contact[email]"]'),
      success_msg = form.querySelector(".form-message--success"),
      spam_msg = form.querySelector(".form-message--spam"),
      error_msg = form.querySelector(".form-message--error"),
      invalid_msg = form.querySelector(".form-message--invalid");
    // submitBtn.addEventListener('click', function (event) {
    //     event.preventDefault();

    //     if (!this.isEmail(emailInput.value)) {
    //         invalid_msg.classList.add('active');
    //         return false;
    //     }
    //     else {
    //         invalid_msg.classList.remove('active');
    //     }

    //     fetch(action, {
    //         method: 'POST',
    //         body: this.getUrlString(this.formToJSON(inputs)),
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    //             'Accept': 'text/html, */*; q=0.01',
    //             'X-Requested-With': 'XMLHttpRequest'
    //         }
    //     }).then(function (response) {

    //         if (response.status == 429) {
    //             spam_msg.classList.add('active');
    //         }
    //         else {
    //             success_msg.classList.add('active');
    //         }
    //     }.bind(this)).catch(function (err) {
    //         console.error(err);
    //         error_msg.classList.add('active');
    //     }).finally(function () {
    //         setTimeout(() => {
    //             success_msg.classList.remove('active');
    //             spam_msg.classList.remove('active');
    //             error_msg.classList.remove('active');
    //         }, 5000);
    //     });
    // }.bind(this));
  }
}
customElements.define("newsletter-form", NewsletterForm);

class BisForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.variantIdInput = this.form.querySelector(
      'input[name="bis_variant_id"]'
    );
    this.productIdInput = this.form.querySelector(
      'input[name="bis_product_id"]'
    );
    this.emailInput = this.form.querySelector('input[name="bis_email"]');
    (this.success_msg = this.form.querySelector(".form-message--success")),
      (this.error_msg = this.form.querySelector(".form-message--error"));
  }
  connectedCallback() {
    this.form.addEventListener(
      "submit",
      function (event) {
        event.preventDefault();
        const email = this.emailInput.value,
          productId = this.productIdInput.value,
          variantId = this.variantIdInput.value;
        BIS.create(email, variantId, productId).then((data) => {
          if (data.status == "OK") {
            this.success_msg.classList.add("active");
          } else {
            this.error_msg.classList.remove("active");
          }
          setTimeout(() => {
            this.success_msg.classList.remove("active");
            this.error_msg.classList.remove("active");
          }, 5000);
        });
      }.bind(this)
    );
  }
}
customElements.define("bis-form", BisForm);

class SelectRadio extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector(".product-option-selected");
    this.list = this?.button?.nextElementSibling;
    this.radios = this?.list?.querySelectorAll('input[type="radio"]');

    this?.addEventListener("focusout", this.onFocusOut.bind(this));
    this?.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this?.button?.addEventListener("click", this.onToggle.bind(this));

    this?.radios?.forEach((radio) => {
      radio?.addEventListener("click", this.onRadioClick.bind(this));
      radio?.addEventListener("keydown", this.onRadioKeyDown.bind(this));
    });
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() == "ESCAPE") {
      this.close();
      // this.button.focus();
    }
  }

  onToggle(event) {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  onRadioClick(event) {
    const radio = event.currentTarget;
    const label = radio.nextElementSibling;
    const labelContent = label.querySelector("span").textContent;
    this.button.querySelector("span").innerHTML = labelContent;

    if (event.clientX === 0 && event.clientY === 0) {
    } else {
      this.close();
    }
  }

  onRadioKeyDown(event) {
    if (
      event.code.toUpperCase() === "ENTER" ||
      event.code.toUpperCase() === "SPACE"
    ) {
      event.preventDefault();
      this.close();
      this.button.focus();
    }
  }

  isOpen() {
    return this.hasAttribute("open");
  }

  open(event) {
    const checkedRadio = Array.from(this.radios).find((radio) => radio.checked);
    this.setAttribute("open", true);
    this.button.setAttribute("aria-expanded", true);
    checkedRadio.focus();
  }

  close(event) {
    this.removeAttribute("open");
    this.button.setAttribute("aria-expanded", false);
  }
}
customElements.define("select-radio", SelectRadio);

class CartSample extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector(".swiper");
  }
  connectedCallback() {
    this.swiper = new Swiper(this.carousel, {
      grabCursor: true,
      slidesPerView: 3.5,
      spaceBetween: 10,
      slidesOffsetBefore: 12,
      slidesOffsetAfter: 12,
      centerInsufficientSlides: false,
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: true,
        sticky: false,
      },
      navigation: {
        prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
        nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
        992: {
          slidesPerView: 3.5,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
        1200: {
          slidesPerView: 4.5,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
      },
    });
  }
}
customElements.define("cart-sample", CartSample);

class CartUpsell extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector(".swiper");
  }
  connectedCallback() {
    this.swiper = new Swiper(this.carousel, {
      grabCursor: true,
      slidesPerView: 1.4,
      spaceBetween: 10,
      slidesOffsetBefore: 12,
      slidesOffsetAfter: 12,
      centerInsufficientSlides: false,
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: true,
        sticky: false,
      },
      navigation: {
        prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
        nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
        disabledClass: "hidden",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
        992: {
          slidesPerView: 2,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
        1200: {
          slidesPerView: 2,
          slidesOffsetBefore: 50,
          slidesOffsetAfter: 50,
        },
      },
    });
  }
}
customElements.define("cart-upsell", CartUpsell);

class CartDrawerUpsell extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector(".swiper");

    this.close = this.querySelector(".cart-drawer-upsell-close");

    this.close.addEventListener("click", this.onCloseClicked.bind(this));
  }

  onCloseClicked() {
    this.remove();
  }

  connectedCallback() {
    let init = false;

    if (window.innerWidth <= 767) {
      if (!init) {
        this.swiper = new Swiper(this.carousel, {
          grabCursor: true,
          slidesPerView: 1.2,
          spaceBetween: 10,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 12,
          centerInsufficientSlides: false,
          mousewheel: {
            forceToAxis: true,
          },
          freeMode: {
            enabled: true,
            sticky: false,
          },
          navigation: {
            prevEl: this.carousel.querySelector(".swiper-nav-button--prev"),
            nextEl: this.carousel.querySelector(".swiper-nav-button--next"),
            disabledClass: "hidden",
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 24,
            },
          },
        });
      }
    } else if (init) {
      this.swiper.destroy();
      init = false;
    }
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);

let init = false;
let ingredientsCarousel = document.querySelector(
  ".product-ingredients-wrapper"
);
if (window.innerWidth <= 1199) {
  if (!init) {
    ingredientsswiper = new Swiper(ingredientsCarousel, {
      grabCursor: true,
      slidesPerView: 1.3,
      spaceBetween: 10,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      centerInsufficientSlides: false,
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: {
        enabled: true,
        sticky: false,
      },
    });
  }
} else if (init) {
  this.ingredientsswiper.destroy();
  init = false;
}

// Shipping Cart Calculator
Shopify.Cart.ShippingCalculator.show({
  submitButton: "Calculate shipping",
  submitButtonDisabled: "Calculating...",
  customerIsLoggedIn: false,
  moneyFormat: "${{amount}}",
});

window.onload = function () {
  // Switch between subsave and one-time purchase for subscription plan through variants.
  let oneTimePurchaseVariant = document.querySelector(
    'select-radio.product-option-select[data-attr="subscribe-and-save"] .product-option-value:last-child'
  );
  let allSubSaveVariants = document.querySelectorAll(
    'select-radio.product-option-select[data-attr="subscribe-and-save"] .product-option-value:not(:last-child)'
  );

  oneTimePurchaseVariant?.addEventListener("click", function () {
    document.querySelector("div[data-option-onetime] input").click();
     // 
         document.querySelector("#pdp-info-inner .product-quantity")
            .classList.remove("hidden");
              document.querySelector("#pdp-info-inner .product-quantity")
            .classList.add("gap-class");

      // 
  });

  allSubSaveVariants?.forEach((item) => {
    item.addEventListener("click", function () {
      document.querySelector("div[data-option-subsave] input").click();
       // 
         document.querySelector("#pdp-info-inner .product-quantity")
            .classList.add("hidden");
                           document.querySelector("#pdp-info-inner .product-quantity")
            .classList.remove("gap-class");

      // 
    });
  });

  var subsaveVariants = document.querySelectorAll(
    "#pdp-info-inner .product-option-value input"
  );
  const pdpATCBtn = document.querySelector(
    ".pdp-main .product-form .product-form__submit"
  );


  // this code is commendted on 6/17/2026 start here  
  // function quantityUpdateSubsaveVarChange(variant) {
  //   if (variant.checked) {
  //     var variantQuantity = variant.getAttribute("data-quantity");

  //     const subsaveProdProp = document.getElementById(
  //       "subsave-tier-pricing-product"
  //     );
  //     console.log("subsaveProdProp: ", subsaveProdProp, variantQuantity);




  //      let  svariantQuantity = Number(variantQuantity);
  //    console.log("top of if  variantQuantity===============>>>>>>>>>>>>>>", variantQuantity);
  //   if (svariantQuantity === 1 || svariantQuantity === 3 || svariantQuantity === 6)
  //    {
  //     console.log("Muneeb is called here") ;

  //     // 
  //        document.querySelector("#pdp-info-inner .product-quantity")
  //           .classList.add("hidden");

  //     // 

  //     document.getElementById("price-to-hide-on-non-onetime").style.display = "none";
  //      document.querySelector('.product-main-pricing').classList.remove('coupon-inline-block');

  //    } 
  //   else {
     
     
    
  //      document.querySelector('.product-main-pricing').classList.add('coupon-inline-block');
  //      document.getElementById("price-to-hide-on-non-onetime").style.display = "inline-block";
      
  //    }




















  //     setTimeout(function () {
  //       if (variantQuantity) {


      
  //         document
  //           .querySelector("#pdp-info-inner .product-quantity")
  //           .classList.add("hidden");
  //         document.querySelector("#pdp-info-inner .quantity__input").value =
  //           variantQuantity;
  //         pdpATCBtn.classList.add("subsave_plan");

  //         var randomNUmber = Math.floor(Math.random() * (999 - 100 + 1) + 100);
  //         subsaveProdProp.setAttribute(
  //           "name",
  //           "properties[subsave-tier-pricing-product-" + randomNUmber + "]"
  //         );
          
  //       } else {
  //         document
  //           .querySelector("#pdp-info-inner .product-quantity")
  //           .classList.remove("hidden");
  //         pdpATCBtn.classList.remove("subsave_plan");

  //         subsaveProdProp.setAttribute(
  //           "name",
  //           "properties[subsave-tier-pricing-product]"
  //         );

        
          
  //       }

  //       pdpATCBtn.classList.remove("disabled");
  //     }, 1000);
  //   }
  // }

  // subsaveVariants.forEach(function (variant) {
  //   quantityUpdateSubsaveVarChange(variant);

  //   variant.addEventListener("change", function () {
  //     pdpATCBtn.classList.add("disabled");
  //     quantityUpdateSubsaveVarChange(variant);
  //   });
  // });





  /* The code that was added to replace this starts below */
  // const notesScrollingSlider = document.querySelector(".notes-list");
  // console.log("notesScrollingSlider===================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",notesScrollingSlider);
  // notesScrollingSlider?.addEventListener("mouseenter", function () {
  //   notesSwiper.autoplay.stop();
  // });
  // notesScrollingSlider?.addEventListener("mouseleave", function () {
  //   notesSwiper.autoplay.start();
  // });
  // this code is commendted on 6/17/2026 ends here 
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  //HOME PAGE BEFORE AFTER SLIDER - PRODUCT PAGE BEFORE AFTE IMAGE SLIDER - PRODUCT PAGE UGC IMAGE SLIDER//
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // HP Before After Slider
  var hpBeforeAfterSlider = new Swiper(".hp-bna_inner", {
    spaceBetween: 20,
    slidesPerView: 1,
    speed: 1000,
    loop: true,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    navigation: {
      prevEl: document
        .querySelector(".hp-bna_inner")
        ?.querySelector(".swiper-nav-button--prev"),
      nextEl: document
        .querySelector(".hp-bna_inner")
        ?.querySelector(".swiper-nav-button--next"),
      disabledClass: "hidden",
    },
    breakpoints: {
      // when window width is >= 1200px
      1200: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
    },
  });




  // BA Product Image Slider

  // 6/17/2026 commented 
  // var baBeforeAfterSlider = new Swiper(".ba-image-products", {
  //   spaceBetween: 20,
  //   slidesPerView: 1,
  //   speed: 1000,
  //   loop: true,
  //   /* autoplay: {
  //       delay: 7000,
  //       pauseOnMouseEnter: true,
  //       disableOnInteraction: false
  //   }, */
  //   navigation: {
  //     prevEl: document
  //       .querySelector(".ba-image-products")
  //       ?.querySelector(".swiper-nav-button--prev"),
  //     nextEl: document
  //       .querySelector(".ba-image-products")
  //       ?.querySelector(".swiper-nav-button--next"),
  //     disabledClass: "hidden",
  //   },
  //   breakpoints: {
  //     // when window width is >= 1200px
  //     1200: {
  //       slidesPerView: 3,
  //       spaceBetween: 50,
  //     },

  //     // when window width is >= 1024px
  //     1024: {
  //       slidesPerView: 2,
  //       spaceBetween: 10,
  //     },
  //   },
  // });



  // 6/17/2026 

  //UGC Products Video Slider//
    var ugcImageSlider = new Swiper(".ugc-image-slider", {
    spaceBetween: 20,
    slidesPerView: 1,
    speed: 1000,
    loop: true,
    /* autoplay: {
        delay: 7000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false
    }, */
    navigation: {
      prevEl: document
        .querySelector(".ugc-image-slider")
        ?.querySelector(".swiper-nav-button--prev"),
      nextEl: document
        .querySelector(".ugc-image-slider")
        ?.querySelector(".swiper-nav-button--next"),
      disabledClass: "hidden",
    },
    breakpoints: {
      // when window width is >= 1200px
      1200: {
        slidesPerView: 5,
        spaceBetween: 20,
      },

      // when window width is >= 1024px
      1024: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      // when window width is >= 767px
      767: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      // when window width is >= 545px
      545: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
  });

  // DOCS Products Video Slider ///////////////////////////////
  var docsImageSlider = new Swiper(".doc-image-slider", {
    spaceBetween: 20,
    slidesPerView: 1,
    speed: 1000,
    loop: true,
    /* autoplay: {
        delay: 7000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false
    }, */
    navigation: {
      prevEl: document
        .querySelector(".doc-image-slider")
        ?.querySelector(".swiper-nav-button--prev"),
      nextEl: document
        .querySelector(".doc-image-slider")
        ?.querySelector(".swiper-nav-button--next"),
      disabledClass: "hidden",
    },
    breakpoints: {
      // when window width is >= 1200px
      1200: {
        slidesPerView: 3,
        spaceBetween: 20,
      },

      // when window width is >= 1024px
      1024: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      // when window width is >= 767px
      767: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      // when window width is >= 545px
      545: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
  });

  // HP Video Slider ///////////////////////////////
  var hpVideoSlider = new Swiper(".hp-video-blog-wrapper", {
    spaceBetween: 20,
    slidesPerView: 1,
    speed: 1000,
    loop: true,
    /* autoplay: {
        delay: 7000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false
    }, */
    navigation: {
      prevEl: document
        .querySelector(".hp-video-blog-wrapper")
        ?.querySelector(".swiper-nav-button--prev"),
      nextEl: document
        .querySelector(".hp-video-blog-wrapper")
        ?.querySelector(".swiper-nav-button--next"),
      disabledClass: "hidden",
    },
    breakpoints: {
      // when window width is >= 1200px
      1200: {
        slidesPerView: 3,
        spaceBetween: 20,
      },

      // when window width is >= 1024px
      1024: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      // when window width is >= 767px
      767: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      // when window width is >= 545px
      545: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
  });
  // Sticky ATC

  // ScrollTrigger.create({
  //     trigger: '#scroll-trigger--product-floaty',
  //     endTrigger: '#scroll-trigger--product-floaty',
  //     start: 'bottom bottom',
  //     end: 'top top',
  //     toggleClass: { targets: '.pdp-main .product-form', className: 'static' },
  // });

  /*   const floatyElOffset = document.getElementById(
    "scroll-trigger--product-floaty"
  ).offsetTop;

  window.addEventListener("scroll", function () {
    var windowScroll = window.pageYOffset + 100;

    if (windowScroll > floatyElOffset) {
      document
        .querySelector(".pdp-main .product-form")
        .classList.remove("static");
    } else {
      document.querySelector(".pdp-main .product-form").classList.add("static");
    }
  }); */





// newly added code start 
    const floatyElOffset = document.getElementById("scroll-trigger--product-floaty").offsetTop + 450;

    window.addEventListener("scroll", function() {
        var windowScroll = window.pageYOffset;

        if (windowScroll > floatyElOffset) {
            document.querySelector(".pdp-main .product-form").classList.remove("static");
        } else {
            document.querySelector(".pdp-main .product-form").classList.add("static");
        }
    });

// newly code added

  

  // Sticky ATC Mobile Customize Button Functionality

  var stickyCustomizeToggle = document.querySelector(
    "#sticky-customize-toggle"
  );
  stickyCustomizeToggle.addEventListener("change", function () {
    if (stickyCustomizeToggle.checked == true) {
      document
        .querySelector(
          ".pdp-main .product-form:not(.static) .rc_container_wrapper"
        )
        ?.classList.add("maxHeight");
      document
        .querySelector(
          ".pdp-main .product-form:not(.static) variant-radios.product-variant-radios"
        )
        ?.classList.add("maxHeight");
    } else {
      document
        .querySelector(
          ".pdp-main .product-form:not(.static) .rc_container_wrapper"
        )
        ?.classList.remove("maxHeight");
      document
        .querySelector(
          ".pdp-main .product-form:not(.static) variant-radios.product-variant-radios"
        )
        ?.classList.remove("maxHeight");
    }
  });

  //START - Iframe Styling

  // Side Cart
  if (document.querySelector(".extend-side-cart-offer div iframe")) {
    let iFrameSideDocument = document.querySelector(
      ".extend-side-cart-offer div iframe"
    ).contentDocument;
    var simpleOffer =
      ".simple-offer { background-color: #F0F0F0 !important; border: none !important; color: #675CB6 !important; padding: 2.1rem 2.5rem !important; height: 6.5rem !important; border-radius: 20px !important; font-size: 12px !important; line-height: 14px !important; font-weight: 600 !important; letter-spacing: 0.3px !important; width: 100% !important; text-transform: capitalize !important; } .simple-offer:hover {box-shadow: 0 0 0 1px inset #675CB6 !important;}";

    var simpleOfferBody = "body { padding-left: 12px !important;}";
    iFrameSideDocument.head.innerHTML =
      iFrameSideDocument.head.innerHTML +
      "<style>" +
      simpleOffer +
      simpleOfferBody +
      "</style>";
  }

  // PDP
    if (document.querySelector(".extend-offer div iframe")) {
    let iFrameDocument = document.querySelector(
      ".extend-offer div iframe"
    ).contentDocument;

    var buttonStyling =
      ".btn-offer { border-color: #000 !important; color: #000; border-radius: 25px !important;padding: 8px !important; font-size: 14px !important; } .btn-offer:hover,.btn-offer:focus-visible {background-color: #000 !important; box-shadow: none !important; border-color: #000 !important; color: #FFF !important;outline-color: #000 !important;} @media only screen and (max-width: 450px) {.btn-offer {padding: 2px 7px !important; font-size: 13px}}";
    var captionStyling =
      ".caption-text {color: #181818 !important; font-size: 14px !important; font-weight: 400 !important; line-height: 25px !important;}";
    var infoLink =
      ".info-link {color:  #181818 !important; font-size: 14px !important; font-weight: 400 !important; line-height: 25px !important; } .info-link:hover { color: #675cb6 !important;}";
    var btnContent =
      "@media only screen and (max-width: 1199px) { .btn-content { display: flex !important; align-items: center !important; justify-content:center !important;font-size: 14px !important; gap: 5px !important; } .term-length, .plan-price { font-size: 14px !important; font-weight: 600 !important;} } @media only screen and (max-width: 500px) {.term-length, .plan-price { font-size: 13px !important;} }";
    iFrameDocument.head.innerHTML =
      iFrameDocument.head.innerHTML +
      "<style>" +
      buttonStyling +
      captionStyling +
      infoLink +
      btnContent +
      "</style>";
  }

  // Cart Page
  if (document.querySelector(".cart-extend-wrapper div iframe")) {
    let iFrameCartDocument = document.querySelector(
      ".cart-extend-wrapper div iframe"
    ).contentDocument;

    var simpleOffer =
      ".simple-offer { background-color: #F0F0F0 !important; border: none !important; color: #675CB6 !important; padding: 2.1rem 2.5rem !important; height: 6.5rem !important; border-radius: 20px !important; font-size: 12px !important; line-height: 14px !important; font-weight: 600 !important; letter-spacing: 0.3px !important; width: 100% !important;} .simple-offer:hover {box-shadow: 0 0 0 1px inset #675CB6 !important;}";
    iFrameCartDocument.head.innerHTML =
      iFrameCartDocument.head.innerHTML + "<style>" + simpleOffer + "</style>";
  }
};
//END - Iframe Styling

waitForElementToExist("#onetrust-group-container").then((element) => {
  // OneTrust <> Shopify User Consent Update.
  OneTrust.OnConsentChanged(function (e) {
    var consentArray = e.detail;

    var marketingConsent = consentArray.indexOf("C0004") == -1 ? false : true; // Targeting - Marketing
    var analyticsConsent = consentArray.indexOf("C0002") == -1 ? false : true; // Performance - Analytics

    const callback = () => {};
    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        analytics: analyticsConsent,
        marketing: marketingConsent,
        preferences: true,
        sale_of_data: marketingConsent,
      },
      callback
    );
  });
});



// new code for subscription issue


document.addEventListener("rebuy:smartcart.line-item-increase", (event) => {
  replaceCartItem();
});
document.addEventListener("rebuy:smartcart.line-item-decrease", (event) => {
  replaceCartItem();
});
document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
  replaceCartItem();
});
window.addEventListener("Rebuy:updated", (event) => {
  replaceCartItem();
});

function replaceCartItem(){
  fetch(window.Shopify.routes.root + "?sections=cart-bubble")
  .then(res => res.json())
  .then(data => {
    if(data){
      const filterData = new DOMParser().parseFromString(data['cart-bubble'], "text/html");
      const cartCount = document.querySelector("#cart-bubble");
      if(cartCount){
        cartCount.innerHTML = filterData.querySelector('#shopify-section-cart-bubble')?.innerHTML;
      }
    }
  });
}
